export const abi = [
  {
    "type": "constructor",
    "inputs": [
      {
        "name": "initialOwner",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "payable"
  },
  {
    "type": "receive",
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "CALL_TYPEHASH",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "DOMAIN_TYPEHASH",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MULTICHAIN_NONCE_PREFIX",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint16",
        "internalType": "uint16"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "USER_OP_TYPEHASH",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "appendAccount",
    "inputs": [
      {
        "name": "id",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "account",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "cancelOwnershipHandover",
    "inputs": [],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "completeOwnershipHandover",
    "inputs": [
      {
        "name": "pendingOwner",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "eip712Domain",
    "inputs": [],
    "outputs": [
      {
        "name": "fields",
        "type": "bytes1",
        "internalType": "bytes1"
      },
      {
        "name": "name",
        "type": "string",
        "internalType": "string"
      },
      {
        "name": "version",
        "type": "string",
        "internalType": "string"
      },
      {
        "name": "chainId",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "verifyingContract",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "salt",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "extensions",
        "type": "uint256[]",
        "internalType": "uint256[]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "execute",
    "inputs": [
      {
        "name": "encodedUserOp",
        "type": "bytes",
        "internalType": "bytes"
      }
    ],
    "outputs": [
      {
        "name": "err",
        "type": "bytes4",
        "internalType": "bytes4"
      }
    ],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "execute",
    "inputs": [
      {
        "name": "encodedUserOps",
        "type": "bytes[]",
        "internalType": "bytes[]"
      }
    ],
    "outputs": [
      {
        "name": "errs",
        "type": "bytes4[]",
        "internalType": "bytes4[]"
      }
    ],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "fill",
    "inputs": [
      {
        "name": "orderId",
        "type": "bytes32",
        "internalType": "bytes32"
      },
      {
        "name": "originData",
        "type": "bytes",
        "internalType": "bytes"
      },
      {
        "name": "",
        "type": "bytes",
        "internalType": "bytes"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bytes4",
        "internalType": "bytes4"
      }
    ],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "getNonce",
    "inputs": [
      {
        "name": "eoa",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "seqKey",
        "type": "uint192",
        "internalType": "uint192"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "idInfos",
    "inputs": [
      {
        "name": "ids",
        "type": "address[]",
        "internalType": "address[]"
      }
    ],
    "outputs": [
      {
        "name": "datas",
        "type": "bytes[]",
        "internalType": "bytes[]"
      },
      {
        "name": "accounts",
        "type": "address[][]",
        "internalType": "address[][]"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "invalidateNonce",
    "inputs": [
      {
        "name": "nonce",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "orderIdIsFilled",
    "inputs": [
      {
        "name": "orderId",
        "type": "bytes32",
        "internalType": "bytes32"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "bool",
        "internalType": "bool"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "owner",
    "inputs": [],
    "outputs": [
      {
        "name": "result",
        "type": "address",
        "internalType": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "ownershipHandoverExpiresAt",
    "inputs": [
      {
        "name": "pendingOwner",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [
      {
        "name": "result",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "register",
    "inputs": [
      {
        "name": "signature",
        "type": "bytes",
        "internalType": "bytes"
      },
      {
        "name": "data",
        "type": "bytes",
        "internalType": "bytes"
      },
      {
        "name": "account",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "removeAccount",
    "inputs": [
      {
        "name": "id",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "renounceOwnership",
    "inputs": [],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "requestOwnershipHandover",
    "inputs": [],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "selfCallPayVerifyCall537021665",
    "inputs": [],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "selfCallSimulateExecute565348489",
    "inputs": [],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "simulateExecute",
    "inputs": [
      {
        "name": "encodedUserOp",
        "type": "bytes",
        "internalType": "bytes"
      }
    ],
    "outputs": [
      {
        "name": "gExecute",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "gCombined",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "gUsed",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "transferOwnership",
    "inputs": [
      {
        "name": "newOwner",
        "type": "address",
        "internalType": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "payable"
  },
  {
    "type": "function",
    "name": "withdrawTokens",
    "inputs": [
      {
        "name": "token",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "recipient",
        "type": "address",
        "internalType": "address"
      },
      {
        "name": "amount",
        "type": "uint256",
        "internalType": "uint256"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "event",
    "name": "NonceInvalidated",
    "inputs": [
      {
        "name": "eoa",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "nonce",
        "type": "uint256",
        "indexed": false,
        "internalType": "uint256"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "OwnershipHandoverCanceled",
    "inputs": [
      {
        "name": "pendingOwner",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "OwnershipHandoverRequested",
    "inputs": [
      {
        "name": "pendingOwner",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "OwnershipTransferred",
    "inputs": [
      {
        "name": "oldOwner",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "newOwner",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "UserOpExecuted",
    "inputs": [
      {
        "name": "eoa",
        "type": "address",
        "indexed": true,
        "internalType": "address"
      },
      {
        "name": "nonce",
        "type": "uint256",
        "indexed": true,
        "internalType": "uint256"
      },
      {
        "name": "incremented",
        "type": "bool",
        "indexed": false,
        "internalType": "bool"
      },
      {
        "name": "err",
        "type": "bytes4",
        "indexed": false,
        "internalType": "bytes4"
      }
    ],
    "anonymous": false
  },
  {
    "type": "error",
    "name": "AlreadyInitialized",
    "inputs": []
  },
  {
    "type": "error",
    "name": "AlreadyRegistered",
    "inputs": []
  },
  {
    "type": "error",
    "name": "CallError",
    "inputs": []
  },
  {
    "type": "error",
    "name": "IDOccupied",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InsufficientGas",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidCaller",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidNonce",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InvalidPreOpEOA",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NewOwnerIsZeroAddress",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NewSequenceMustBeLarger",
    "inputs": []
  },
  {
    "type": "error",
    "name": "NoHandoverRequest",
    "inputs": []
  },
  {
    "type": "error",
    "name": "OrderAlreadyFilled",
    "inputs": []
  },
  {
    "type": "error",
    "name": "PaymentError",
    "inputs": []
  },
  {
    "type": "error",
    "name": "PreOpCallError",
    "inputs": []
  },
  {
    "type": "error",
    "name": "PreOpVerificationError",
    "inputs": []
  },
  {
    "type": "error",
    "name": "Reentrancy",
    "inputs": []
  },
  {
    "type": "error",
    "name": "SimulateExecuteFailed",
    "inputs": []
  },
  {
    "type": "error",
    "name": "SimulationResult",
    "inputs": [
      {
        "name": "gExecute",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "gCombined",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "gUsed",
        "type": "uint256",
        "internalType": "uint256"
      },
      {
        "name": "err",
        "type": "bytes4",
        "internalType": "bytes4"
      }
    ]
  },
  {
    "type": "error",
    "name": "Unauthorized",
    "inputs": []
  },
  {
    "type": "error",
    "name": "UnauthorizedCallContext",
    "inputs": []
  },
  {
    "type": "error",
    "name": "VerificationError",
    "inputs": []
  },
  {
    "type": "error",
    "name": "VerifiedCallError",
    "inputs": []
  }
] as const;

export const code = "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" as const;

